import { Redirect, Switch, Route, useRouteMatch } from 'react-router'

import styles from './styles/PartnersPage.css'
import { useLocation } from 'react-router-dom'
import classNames from 'classnames'
import { Header } from '../components/typography/Header'
import PartnersLinkPanel from '../components/partners/PartnersLinkPanel'
import PublishersPanel from '../components/partners/PublishersPanel'
import InstitutionsPanel from '../components/partners/InstitutionsPanel'
import PharmaPanel from '../components/partners/PharmaPanel'
import ResearchersPanel from '../components/partners/ResearchersPanel'
import StudentsPanel from '../components/partners/StudentsPanel'
import NavBar from '../components/navbar/NavBar'
import { Helmet } from 'react-helmet'

const METADATA = {
  '/partners/publishers': {
    title: 'Publishers',
    subheader: 'Make your content discoverable and drive traffic to your publications',
    titleCopy: 'scite for Publishers',
    descCopy: 'Improve discoverability and ensure the quality of your publications with scite badges, journal index, and reference check',
    image: `${CONFIG.assetsBaseURL}/images/illustrations/journal-badge-illo-3.svg`
  },
  '/partners/academic-institutions': {
    title: 'Academic Institutions & Libraries',
    subheader: ' Improve research outcomes across your organization',
    titleCopy: 'scite for Academic Institutions & Libraries',
    descCopy: 'Improve research quality and keep track of research outputs with scite dashboards'
  },
  '/partners/pharmaceuticals-and-biotech': {
    title: 'Pharmaceuticals & Biotech',
    subheader: 'Stay up to date on how your research assets are being used and talked about',
    titleCopy: 'scite For Pharmaceuticals & Biotech',
    descCopy: 'Assess research and researchers better. Improve efficiency of research with scite dashboards'
  },
  '/partners/researchers': {
    title: 'Researchers',
    subheader: 'Find out how studies have been supported, replicated, disputed, criticized, etc.',
    titleCopy: 'scite for Researchers',
    descCopy: 'Evaluate research articles better to find information that is otherwise buried. Improve research quality with contextualized smart citations'
  },
  '/partners/students': {
    title: 'Students',
    subheader: 'Find articles worth citing or reading and see whether experts have supported or disputed their findings',
    titleCopy: 'scite for Students',
    descCopy: 'Finding research and understanding what to cite is hard. Use scite to find citations for your research projects and understand if they have been supported or contrasted.'
  }
}

export const PartnersPage = () => {
  const { pathname } = useLocation()
  const { path } = useRouteMatch()

  if (!Object.keys(METADATA).includes(pathname)) {
    return (
      <Redirect to='/partners/pharmaceuticals-and-biotech' />
    )
  }

  return (
    <div className={styles.layout}>
      <div className={classNames(styles.hero, {
        [styles.publisherLayout]: pathname === '/partners/publishers',
        [styles.institutionsLayout]: pathname === '/partners/academic-institutions',
        [styles.randdLayout]: pathname === '/partners/pharmaceuticals-and-biotech',
        [styles.researchersLayout]: pathname === '/partners/researchers',
        [styles.fundersLayout]: pathname === '/partners/students'
      })}
      >
        <Helmet>
          <title>{METADATA[pathname].titleCopy}</title>
          <meta property='title' content={METADATA[pathname].titleCopy} />
          <meta property='og:title' content={METADATA[pathname].titleCopy} />
          <meta property='twitter:title' content={METADATA[pathname].titleCopy} />

          <meta name='description' content={METADATA[pathname].descCopy} />
          <meta property='og:description' content={METADATA[pathname].descCopy} />
          <meta property='twitter:description' content={METADATA[pathname].descCopy} />

          <meta property='og:image' content={`http://image.thum.io/get/ogImage/https://scite.ai${pathname}?bannerClosed=true`} />
          <meta property='twitter:image' content={`http://image.thum.io/get/ogImage/https://scite.ai${pathname}?bannerClosed=true`} />

        </Helmet>
        <NavBar staticPage />
        <Header level={2} className={styles.titleHeader}>{METADATA[pathname].title}</Header>
        <Header level={4} className={styles.titleSubheader}>{METADATA[pathname].subheader}</Header>
        <PartnersLinkPanel />
      </div>
      <div className={styles.body}>
        <Switch>
          <Route path={`${path}/publishers`} component={PublishersPanel} />
          <Route path={`${path}/academic-institutions`} component={InstitutionsPanel} />
          <Route path={`${path}/researchers`} component={ResearchersPanel} />
          <Route path={`${path}/pharmaceuticals-and-biotech`} component={PharmaPanel} />
          <Route path={`${path}/students`} component={StudentsPanel} />
        </Switch>
      </div>
    </div>
  )
}

export default PartnersPage
